import "../../styles/comparison-points.css";
type Props = {
  label: string;
  names: [string, string];
  values: [number | null, number | null];
  higherWins?: boolean;
  percentage?: boolean;
  decimals?: number;
  sample: string;
  description?: string;
};
export function ComparisonPoints({
  label,
  names,
  values,
  higherWins = false,
  percentage = false,
  decimals = 1,
  sample,
  description,
}: Props): React.JSX.Element {
  const complete = values.every((v) => v != null && Number.isFinite(v));
  let winner =
    !complete || values[0] === values[1]
      ? -1
      : (higherWins ? values[0]! > values[1]! : values[0]! < values[1]!)
        ? 0
        : 1;
  const numeric = values.map((v) =>
    v == null ? null : percentage ? v * 100 : v,
  );
  const precision = percentage ? 0 : Math.max(0, Math.min(2, decimals));
  const sameRounded =
    complete &&
    numeric[0]!.toFixed(precision) === numeric[1]!.toFixed(precision);
  const shownPrecision =
    sameRounded && winner !== -1 ? Math.min(2, precision + 2) : precision;
  if (
    complete &&
    numeric[0]!.toFixed(shownPrecision) === numeric[1]!.toFixed(shownPrecision)
  )
    winner = -1;
  const format = (v: number | null) =>
    v == null || !Number.isFinite(v)
      ? "—"
      : v.toFixed(shownPrecision) + (percentage ? "%" : "");
  return (
    <article className="rc-points">
      <header>
        <h3>{label}</h3>
        <p>
          {description ??
            (higherWins
              ? "Higher is better"
              : "Average strokes · Lower is better")}
        </p>
      </header>
      <div className="rc-points-people">
        {names.map((name, index) => (
          <div key={index} data-leading={winner === index}>
            <span>{name}</span>
            <strong
              aria-label={
                name +
                ": " +
                format(numeric[index]!) +
                (winner === index ? ", best" : "")
              }
            >
              {format(numeric[index]!)}
            </strong>
          </div>
        ))}
      </div>
      <small>
        {sample}
        {complete && values[0] === values[1] ? " · Even" : ""}
      </small>
    </article>
  );
}
